// extracted by mini-css-extract-plugin
export default {"btnHolder":"UserSupportTable_btnHolder__9BXt3","orderBtn":"UserSupportTable_orderBtn__Y6O0N","mapBtn":"UserSupportTable_mapBtn__GAvkC","feedback":"UserSupportTable_feedback__v6bYZ"};